// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Map Object Popup - Theme-Aware Design */

/* Content styling only - outer wrapper (border-radius, shadow, width)
   is handled by the tabbed popup system */
.map-object-popup {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--cfn-text-primary);
  background: var(--cfn-popup-bg);
  overflow: hidden;
}

/* Header Section */
.map-object-popup__header {
  display: flex;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
  background: var(--cfn-modal-header-bg);
  border-left: 4px solid var(--accent-color, var(--cfn-accent-primary));
  position: relative;
}

.map-object-popup__header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--accent-color, var(--cfn-accent-primary)) 20%,
    var(--accent-color, var(--cfn-accent-primary)) 80%,
    transparent
  );
  opacity: 0.5;
}

.map-object-popup__header-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--accent-color, var(--cfn-accent-primary));
  color: #ffffff;
  font-size: 1rem;
  box-shadow: var(--cfn-shadow-md);
}

.map-object-popup__header-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.map-object-popup__title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.map-object-popup__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--cfn-text-primary);
  word-wrap: break-word;
}

.map-object-popup__type-badge {
  display: inline-flex;
  padding: 0.125rem 0.5rem;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: var(--cfn-accent-primary-muted);
  color: var(--cfn-accent-primary-text);
  border: 1px solid var(--cfn-accent-primary);
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0.8;
}

/* Link button in header */
.map-object-popup__link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--cfn-border-muted);
  border-radius: 4px;
  color: var(--cfn-text-muted);
  font-size: 0.6875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.map-object-popup__link-btn:hover {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-accent-primary);
}

.map-object-popup__link-btn.copied {
  background: var(--cfn-success-muted, rgba(16, 185, 129, 0.15));
  border-color: var(--cfn-success, #10b981);
  color: var(--cfn-success, #10b981);
}

.map-object-popup__meta-row {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  color: var(--cfn-text-muted);
  flex-wrap: wrap;
}

.map-object-popup__separator {
  opacity: 0.5;
}

.map-object-popup__network {
  color: var(--cfn-text-secondary);
  font-weight: 500;
}

.map-object-popup__subtitle {
  color: var(--cfn-text-muted);
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

/* Actions Section */
.map-object-popup__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.375rem 0.5rem;
  background: var(--cfn-modal-footer-bg);
  border-top: 1px solid var(--cfn-border-muted);
  border-bottom: 1px solid var(--cfn-border-muted);
}

.map-object-popup__action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.0625rem;
  min-width: 42px;
  max-width: 52px;
  padding: 0.25rem 0.375rem;
  background: var(--cfn-btn-secondary-bg);
  border: 1px solid var(--cfn-border);
  border-radius: 6px;
  color: var(--cfn-text-secondary);
  font-size: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.map-object-popup__action-btn i {
  font-size: 0.8rem;
}

.map-object-popup__action-btn--primary {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-accent-primary-text);
}

.map-object-popup__action-btn--primary:hover {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-accent-primary-hover);
  color: var(--cfn-btn-primary-text);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px var(--cfn-focus-ring);
}

.map-object-popup__action-btn--secondary:hover {
  background: var(--cfn-btn-secondary-hover-bg);
  border-color: var(--cfn-border-strong);
  color: var(--cfn-text-primary);
  transform: translateY(-1px);
}

.map-object-popup__action-btn--active {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-accent-primary-text);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
}

.map-object-popup__action-btn--danger {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-danger);
  color: var(--cfn-danger-text);
}

.map-object-popup__action-btn--danger:hover {
  background: var(--cfn-btn-danger-hover-bg);
  border-color: var(--cfn-danger);
  color: var(--cfn-danger-text);
  transform: translateY(-1px);
}

/* Properties Section */
.map-object-popup__properties-section {
  max-height: 200px;
  overflow-y: auto;
  padding: 0.375rem 0.5rem;
  border-top: 1px solid var(--cfn-border-muted);
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-bg-secondary);
  scrollbar-width: thin;
  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);
}

.map-object-popup__properties-section::-webkit-scrollbar {
  width: 6px;
}

.map-object-popup__properties-section::-webkit-scrollbar-track {
  background: var(--cfn-scrollbar-track);
}

.map-object-popup__properties-section::-webkit-scrollbar-thumb {
  background: var(--cfn-scrollbar-thumb);
  border-radius: 3px;
}

.map-object-popup__properties-section::-webkit-scrollbar-thumb:hover {
  background: var(--cfn-scrollbar-thumb-hover);
}

.map-object-popup__properties {
  display: grid;
  grid-template-columns: minmax(0, 80px) minmax(0, 1fr);
  -moz-column-gap: 0.375rem;
       column-gap: 0.375rem;
  row-gap: 0.25rem;
  margin: 0;
}

.map-object-popup__properties dt {
  color: var(--cfn-text-muted);
  font-size: 0.5625rem;
  font-weight: 500;
  text-transform: capitalize;
  margin: 0;
  padding-top: 0.0625rem;
}

.map-object-popup__properties dd {
  color: var(--cfn-text-primary);
  font-size: 0.6875rem;
  margin: 0;
  word-wrap: break-word;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

.map-object-popup__properties dd a {
  color: var(--cfn-accent-primary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.map-object-popup__properties dd a:hover {
  color: var(--cfn-accent-primary-text);
  text-decoration: underline;
}

/* Footer CTAs */
.map-object-popup__footer {
  display: flex;
  gap: 0.375rem;
  padding: 0.5rem 0.75rem;
  background: var(--cfn-modal-footer-bg);
  border-top: 1px solid var(--cfn-border-muted);
}

.map-object-popup__cta-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.375rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.map-object-popup__cta-btn i {
  font-size: 0.875rem;
}

.map-object-popup__cta-btn--primary {
  background: var(--cfn-btn-primary-bg);
  color: var(--cfn-btn-primary-text);
  box-shadow: 0 2px 8px var(--cfn-focus-ring);
}

.map-object-popup__cta-btn--primary:hover {
  background: var(--cfn-btn-primary-hover-bg);
  box-shadow: 0 4px 12px var(--cfn-focus-ring);
  transform: translateY(-1px);
}

.map-object-popup__cta-btn--secondary {
  background: var(--cfn-btn-secondary-bg);
  border: 1px solid var(--cfn-border);
  color: var(--cfn-text-secondary);
}

.map-object-popup__cta-btn--secondary:hover {
  background: var(--cfn-btn-secondary-hover-bg);
  border-color: var(--cfn-border-strong);
  color: var(--cfn-text-primary);
  transform: translateY(-1px);
}

/* Tabs Section */
.map-object-popup__tabs {
  border-top: 1px solid var(--cfn-border-muted);
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-footer-bg);
}

.map-object-popup__tab-list {
  display: flex;
  gap: 0;
}

.map-object-popup__tab {
  flex: 1;
  padding: 0.375rem 0.5rem;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--cfn-text-muted);
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s ease;
}

.map-object-popup__tab:hover {
  color: var(--cfn-text-secondary);
  background: var(--cfn-bg-elevated);
}

.map-object-popup__tab.active {
  color: var(--cfn-accent-primary);
  border-bottom-color: var(--cfn-accent-primary);
  background: var(--cfn-accent-primary-muted);
}

/* Aggregation Nodes Section */
.map-object-popup__agg-nodes {
  padding: 0.5rem 0.5rem;
  background: var(--cfn-bg-secondary);
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);
}

.map-object-popup__agg-nodes::-webkit-scrollbar {
  width: 6px;
}

.map-object-popup__agg-nodes::-webkit-scrollbar-track {
  background: var(--cfn-scrollbar-track);
}

.map-object-popup__agg-nodes::-webkit-scrollbar-thumb {
  background: var(--cfn-scrollbar-thumb);
  border-radius: 3px;
}

.map-object-popup__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: var(--cfn-text-muted);
}

/* Custom spinner to replace Bootstrap spinner-border */
.map-object-popup__spinner {
  width: 2rem;
  height: 2rem;
  border: 0.2em solid var(--cfn-spinner-track);
  border-right-color: var(--cfn-spinner-fill);
  border-radius: 50%;
  animation: map-object-popup-spin 0.75s linear infinite;
}

@keyframes map-object-popup-spin {
  to {
    transform: rotate(360deg);
  }
}

.map-object-popup__empty {
  text-align: center;
  padding: 1.5rem 1rem;
  color: var(--cfn-text-muted);
}

.map-object-popup__empty p {
  margin: 0 0 1rem 0;
  font-size: 0.875rem;
}

.map-object-popup__add-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--cfn-accent-primary-muted);
  border: 1px solid var(--cfn-accent-primary);
  border-radius: 6px;
  color: var(--cfn-accent-primary-text);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.75rem;
}

.map-object-popup__add-btn:hover {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-accent-primary-hover);
  color: var(--cfn-btn-primary-text);
  transform: translateY(-1px);
}

.map-object-popup__agg-nodes-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.map-object-popup__agg-node {
  padding: 0.5rem;
  background: var(--cfn-bg-tertiary);
  border: 1px solid var(--cfn-border-muted);
  border-radius: 6px;
  transition: all 0.2s ease;
}

.map-object-popup__agg-node:hover {
  background: var(--cfn-bg-elevated);
  border-color: var(--cfn-border);
}

.map-object-popup__agg-node-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 0.375rem;
}

.map-object-popup__agg-node-type {
  padding: 0.0625rem 0.375rem;
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 3px;
  color: #c4b5fd;
  font-size: 0.5rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.theme-light .map-object-popup__agg-node-type {
  background: rgba(139, 92, 246, 0.1);
  color: #7c3aed;
}

.map-object-popup__agg-node-id {
  flex: 1;
  color: var(--cfn-text-primary);
  font-size: 0.6875rem;
  font-weight: 600;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  text-align: right;
}

.map-object-popup__agg-node-noi {
  color: var(--cfn-text-muted);
  font-size: 0.5625rem;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  margin-bottom: 0.25rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid var(--cfn-border-muted);
}

.map-object-popup__agg-node-description {
  color: var(--cfn-text-secondary);
  font-size: 0.625rem;
  line-height: 1.3;
  margin-bottom: 0.375rem;
}

.map-object-popup__agg-node-actions {
  display: flex;
  gap: 0.375rem;
  justify-content: flex-end;
}

.map-object-popup__agg-node-btn {
  padding: 0.375rem 0.625rem;
  background: var(--cfn-accent-primary-muted);
  border: 1px solid var(--cfn-accent-primary);
  border-radius: 4px;
  color: var(--cfn-accent-primary);
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.map-object-popup__agg-node-btn:hover {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-accent-primary-hover);
  color: var(--cfn-btn-primary-text);
  transform: translateY(-1px);
}

/* More Actions Dropdown */
.map-object-popup__more-actions {
  position: relative;
}

.map-object-popup__more-dropdown {
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  min-width: 150px;
  background: var(--cfn-popup-bg);
  border: 1px solid var(--cfn-border);
  border-radius: 6px;
  box-shadow: var(--cfn-shadow-lg);
  z-index: 100;
  overflow: hidden;
}

.map-object-popup__more-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.625rem 0.875rem;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--cfn-border-muted);
  color: var(--cfn-text-secondary);
  font-size: 0.75rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.map-object-popup__more-item:last-child {
  border-bottom: none;
}

.map-object-popup__more-item:hover {
  background: var(--cfn-accent-primary-muted);
  color: var(--cfn-accent-primary-text);
}

.map-object-popup__more-item i {
  width: 1rem;
  text-align: center;
  font-size: 0.875rem;
}


/* Responsive adjustments */
@media (max-width: 480px) {
  .map-object-popup__header {
    padding: 0.625rem 0.875rem;
  }

  .map-object-popup__actions {
    padding: 0.5rem 0.875rem;
    gap: 0.3125rem;
  }

  .map-object-popup__action-btn {
    padding: 0.4375rem 0.3125rem;
    font-size: 0.5625rem;
  }

  .map-object-popup__action-btn i {
    font-size: 0.9375rem;
  }

  .map-object-popup__properties-section {
    padding: 0.625rem 0.875rem;
  }

  .map-object-popup__footer {
    padding: 0.5rem 0.875rem;
    flex-direction: column;
    gap: 0.375rem;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   PHOTO MINI-GALLERY STYLES
   ═══════════════════════════════════════════════════════════════════════════ */

.photo-mini-gallery {
  padding: 8px;
}

.photo-mini-gallery__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px 8px;
  font-size: 12px;
  color: var(--cfn-text-secondary, #6b7280);
}

.photo-mini-gallery__count {
  font-weight: 500;
  color: var(--cfn-text-primary, #333);
}

.photo-mini-gallery__radius {
  font-size: 11px;
}

.photo-mini-gallery__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  max-height: 280px;
  overflow-y: auto;
}

.photo-mini-gallery__item {
  position: relative;
  aspect-ratio: 1;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  background: var(--cfn-bg-secondary, #f3f4f6);
  transition: transform 0.15s ease;
}

.photo-mini-gallery__item:hover {
  transform: scale(1.02);
}

.photo-mini-gallery__item:active {
  transform: scale(0.98);
}

.photo-mini-gallery__item img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  transition: opacity 0.2s ease;
}

.photo-mini-gallery__item img[src=""] {
  opacity: 0;
}

.photo-mini-gallery__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2px 4px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  display: flex;
  justify-content: flex-end;
}

.photo-mini-gallery__distance {
  font-size: 10px;
  font-weight: 500;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* Entity link badge on thumbnail */
.photo-mini-gallery__entity {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 4px;
  background: rgba(0, 0, 0, 0.75);
}

.photo-mini-gallery__entity-link,
.photo-mini-gallery__entity-text {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  color: white;
  text-decoration: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.photo-mini-gallery__entity-link:hover {
  color: #60a5fa;
  text-decoration: underline;
}

.photo-mini-gallery__entity-link i,
.photo-mini-gallery__entity-text i {
  font-size: 10px;
  flex-shrink: 0;
}

.photo-mini-gallery__entity-link span,
.photo-mini-gallery__entity-text span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Loading state */
.photo-mini-gallery--loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  color: var(--cfn-text-secondary, #6b7280);
  font-size: 12px;
}

.photo-mini-gallery__spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--cfn-bg-tertiary, #e5e7eb);
  border-top-color: var(--cfn-primary, #3b82f6);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Error state */
.photo-mini-gallery--error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  color: var(--cfn-danger, #ef4444);
  font-size: 12px;
}

.photo-mini-gallery--error i {
  font-size: 18px;
}

/* Empty state */
.photo-mini-gallery--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  color: var(--cfn-text-tertiary, #9ca3af);
  font-size: 12px;
}

.photo-mini-gallery--empty i {
  font-size: 24px;
}

/* Mobile adjustments */
@media (max-width: 480px) {
  .photo-mini-gallery__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .photo-mini-gallery__distance {
    font-size: 11px;
  }
}

/* ============================================
   BFT (Blown Fibre Tubing) Nested Tabs
   For multiple BFTs on the same conduit
   ============================================ */

.map-object-popup__bft-content {
  padding: 0;
}

.map-object-popup__bft-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px 10px;
  background: var(--cfn-bg-tertiary);
  border-bottom: 1px solid var(--cfn-border);
}

.map-object-popup__bft-tab {
  padding: 4px 10px;
  background: var(--cfn-bg-secondary);
  border: 1px solid var(--cfn-border);
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: var(--cfn-text-muted);
  transition: all 0.15s ease;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-object-popup__bft-tab:hover {
  background: var(--cfn-bg-primary);
  color: var(--cfn-text-primary);
  border-color: #7c3aed; /* violet - BFT accent */
}

.map-object-popup__bft-tab.active {
  background: #7c3aed; /* violet - BFT accent */
  color: #ffffff;
  border-color: #7c3aed;
}

/* BFT properties within content */
.map-object-popup__bft-content .map-object-popup__properties-section {
  padding: 8px 10px;
}

.map-object-popup__bft-content .map-object-popup__properties {
  margin: 0;
}

.map-object-popup__bft-content .map-object-popup__properties dt {
  font-size: 11px;
}

.map-object-popup__bft-content .map-object-popup__properties dd {
  font-size: 12px;
}

/* ============================================
   Conduit/Duct Nested Tabs
   For multiple conduits at the same structure
   ============================================ */

.map-object-popup__conduit-content {
  padding: 0;
}

.map-object-popup__conduit-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px 10px;
  background: var(--cfn-bg-tertiary);
  border-bottom: 1px solid var(--cfn-border);
}

.map-object-popup__conduit-tab {
  padding: 4px 10px;
  background: var(--cfn-bg-secondary);
  border: 1px solid var(--cfn-border);
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: var(--cfn-text-muted);
  transition: all 0.15s ease;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-object-popup__conduit-tab:hover {
  background: var(--cfn-bg-primary);
  color: var(--cfn-text-primary);
  border-color: #ec4899; /* pink - conduit accent */
}

.map-object-popup__conduit-tab.active {
  background: #ec4899; /* pink - conduit accent */
  color: #ffffff;
  border-color: #ec4899;
}

/* Conduit properties within content */
.map-object-popup__conduit-content .map-object-popup__properties-section {
  padding: 8px 10px;
}

.map-object-popup__conduit-content .map-object-popup__properties {
  margin: 0;
}

.map-object-popup__conduit-content .map-object-popup__properties dt {
  font-size: 11px;
}

.map-object-popup__conduit-content .map-object-popup__properties dd {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/map-object-popup.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;0CAC0C;AAC1C;EACE,yGAAyG;EACzG,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,8DAA8D;EAC9D,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2DAA2D;AAC7D;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,sCAAsC;EACtC,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,mCAAmC;EACnC,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,6CAA6C;EAC7C,gDAAgD;EAChD,mCAAmC;EACnC,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,yBAAoB;OAApB,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;EACT,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,6CAA6C;EAC7C,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,MAAM;AACR;;AAEA;EACE,OAAO;EACP,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,2CAA2C;EAC3C,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,2DAA2D;EAC3D,sBAAsB;EACtB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,gDAAgD;EAChD,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;;gFAEgF;;AAEhF;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,4DAA4D;EAC5D,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,6CAA6C;EAC7C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;iDAGiD;;AAEjD;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,qBAAqB,EAAE,wBAAwB;AACjD;;AAEA;EACE,mBAAmB,EAAE,wBAAwB;EAC7C,cAAc;EACd,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;iDAGiD;;AAEjD;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,cAAc;EACd,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Map Object Popup - Theme-Aware Design */\n\n/* Content styling only - outer wrapper (border-radius, shadow, width)\n   is handled by the tabbed popup system */\n.map-object-popup {\n  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--cfn-text-primary);\n  background: var(--cfn-popup-bg);\n  overflow: hidden;\n}\n\n/* Header Section */\n.map-object-popup__header {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.625rem 0.75rem;\n  background: var(--cfn-modal-header-bg);\n  border-left: 4px solid var(--accent-color, var(--cfn-accent-primary));\n  position: relative;\n}\n\n.map-object-popup__header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    var(--accent-color, var(--cfn-accent-primary)) 20%,\n    var(--accent-color, var(--cfn-accent-primary)) 80%,\n    transparent\n  );\n  opacity: 0.5;\n}\n\n.map-object-popup__header-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: var(--accent-color, var(--cfn-accent-primary));\n  color: #ffffff;\n  font-size: 1rem;\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.map-object-popup__header-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.map-object-popup__title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.map-object-popup__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--cfn-text-primary);\n  word-wrap: break-word;\n}\n\n.map-object-popup__type-badge {\n  display: inline-flex;\n  padding: 0.125rem 0.5rem;\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: var(--cfn-accent-primary-muted);\n  color: var(--cfn-accent-primary-text);\n  border: 1px solid var(--cfn-accent-primary);\n  border-radius: 4px;\n  white-space: nowrap;\n  opacity: 0.8;\n}\n\n/* Link button in header */\n.map-object-popup__link-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--cfn-border-muted);\n  border-radius: 4px;\n  color: var(--cfn-text-muted);\n  font-size: 0.6875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.map-object-popup__link-btn:hover {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-accent-primary);\n}\n\n.map-object-popup__link-btn.copied {\n  background: var(--cfn-success-muted, rgba(16, 185, 129, 0.15));\n  border-color: var(--cfn-success, #10b981);\n  color: var(--cfn-success, #10b981);\n}\n\n.map-object-popup__meta-row {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.75rem;\n  color: var(--cfn-text-muted);\n  flex-wrap: wrap;\n}\n\n.map-object-popup__separator {\n  opacity: 0.5;\n}\n\n.map-object-popup__network {\n  color: var(--cfn-text-secondary);\n  font-weight: 500;\n}\n\n.map-object-popup__subtitle {\n  color: var(--cfn-text-muted);\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n}\n\n/* Actions Section */\n.map-object-popup__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  padding: 0.375rem 0.5rem;\n  background: var(--cfn-modal-footer-bg);\n  border-top: 1px solid var(--cfn-border-muted);\n  border-bottom: 1px solid var(--cfn-border-muted);\n}\n\n.map-object-popup__action-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.0625rem;\n  min-width: 42px;\n  max-width: 52px;\n  padding: 0.25rem 0.375rem;\n  background: var(--cfn-btn-secondary-bg);\n  border: 1px solid var(--cfn-border);\n  border-radius: 6px;\n  color: var(--cfn-text-secondary);\n  font-size: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.map-object-popup__action-btn i {\n  font-size: 0.8rem;\n}\n\n.map-object-popup__action-btn--primary {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-accent-primary-text);\n}\n\n.map-object-popup__action-btn--primary:hover {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-accent-primary-hover);\n  color: var(--cfn-btn-primary-text);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px var(--cfn-focus-ring);\n}\n\n.map-object-popup__action-btn--secondary:hover {\n  background: var(--cfn-btn-secondary-hover-bg);\n  border-color: var(--cfn-border-strong);\n  color: var(--cfn-text-primary);\n  transform: translateY(-1px);\n}\n\n.map-object-popup__action-btn--active {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-accent-primary-text);\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n.map-object-popup__action-btn--danger {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-danger);\n  color: var(--cfn-danger-text);\n}\n\n.map-object-popup__action-btn--danger:hover {\n  background: var(--cfn-btn-danger-hover-bg);\n  border-color: var(--cfn-danger);\n  color: var(--cfn-danger-text);\n  transform: translateY(-1px);\n}\n\n/* Properties Section */\n.map-object-popup__properties-section {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 0.375rem 0.5rem;\n  border-top: 1px solid var(--cfn-border-muted);\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-bg-secondary);\n  scrollbar-width: thin;\n  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);\n}\n\n.map-object-popup__properties-section::-webkit-scrollbar {\n  width: 6px;\n}\n\n.map-object-popup__properties-section::-webkit-scrollbar-track {\n  background: var(--cfn-scrollbar-track);\n}\n\n.map-object-popup__properties-section::-webkit-scrollbar-thumb {\n  background: var(--cfn-scrollbar-thumb);\n  border-radius: 3px;\n}\n\n.map-object-popup__properties-section::-webkit-scrollbar-thumb:hover {\n  background: var(--cfn-scrollbar-thumb-hover);\n}\n\n.map-object-popup__properties {\n  display: grid;\n  grid-template-columns: minmax(0, 80px) minmax(0, 1fr);\n  column-gap: 0.375rem;\n  row-gap: 0.25rem;\n  margin: 0;\n}\n\n.map-object-popup__properties dt {\n  color: var(--cfn-text-muted);\n  font-size: 0.5625rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  margin: 0;\n  padding-top: 0.0625rem;\n}\n\n.map-object-popup__properties dd {\n  color: var(--cfn-text-primary);\n  font-size: 0.6875rem;\n  margin: 0;\n  word-wrap: break-word;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n}\n\n.map-object-popup__properties dd a {\n  color: var(--cfn-accent-primary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.map-object-popup__properties dd a:hover {\n  color: var(--cfn-accent-primary-text);\n  text-decoration: underline;\n}\n\n/* Footer CTAs */\n.map-object-popup__footer {\n  display: flex;\n  gap: 0.375rem;\n  padding: 0.5rem 0.75rem;\n  background: var(--cfn-modal-footer-bg);\n  border-top: 1px solid var(--cfn-border-muted);\n}\n\n.map-object-popup__cta-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 0.375rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.map-object-popup__cta-btn i {\n  font-size: 0.875rem;\n}\n\n.map-object-popup__cta-btn--primary {\n  background: var(--cfn-btn-primary-bg);\n  color: var(--cfn-btn-primary-text);\n  box-shadow: 0 2px 8px var(--cfn-focus-ring);\n}\n\n.map-object-popup__cta-btn--primary:hover {\n  background: var(--cfn-btn-primary-hover-bg);\n  box-shadow: 0 4px 12px var(--cfn-focus-ring);\n  transform: translateY(-1px);\n}\n\n.map-object-popup__cta-btn--secondary {\n  background: var(--cfn-btn-secondary-bg);\n  border: 1px solid var(--cfn-border);\n  color: var(--cfn-text-secondary);\n}\n\n.map-object-popup__cta-btn--secondary:hover {\n  background: var(--cfn-btn-secondary-hover-bg);\n  border-color: var(--cfn-border-strong);\n  color: var(--cfn-text-primary);\n  transform: translateY(-1px);\n}\n\n/* Tabs Section */\n.map-object-popup__tabs {\n  border-top: 1px solid var(--cfn-border-muted);\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-footer-bg);\n}\n\n.map-object-popup__tab-list {\n  display: flex;\n  gap: 0;\n}\n\n.map-object-popup__tab {\n  flex: 1;\n  padding: 0.375rem 0.5rem;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: var(--cfn-text-muted);\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.map-object-popup__tab:hover {\n  color: var(--cfn-text-secondary);\n  background: var(--cfn-bg-elevated);\n}\n\n.map-object-popup__tab.active {\n  color: var(--cfn-accent-primary);\n  border-bottom-color: var(--cfn-accent-primary);\n  background: var(--cfn-accent-primary-muted);\n}\n\n/* Aggregation Nodes Section */\n.map-object-popup__agg-nodes {\n  padding: 0.5rem 0.5rem;\n  background: var(--cfn-bg-secondary);\n  max-height: 200px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);\n}\n\n.map-object-popup__agg-nodes::-webkit-scrollbar {\n  width: 6px;\n}\n\n.map-object-popup__agg-nodes::-webkit-scrollbar-track {\n  background: var(--cfn-scrollbar-track);\n}\n\n.map-object-popup__agg-nodes::-webkit-scrollbar-thumb {\n  background: var(--cfn-scrollbar-thumb);\n  border-radius: 3px;\n}\n\n.map-object-popup__loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  color: var(--cfn-text-muted);\n}\n\n/* Custom spinner to replace Bootstrap spinner-border */\n.map-object-popup__spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 0.2em solid var(--cfn-spinner-track);\n  border-right-color: var(--cfn-spinner-fill);\n  border-radius: 50%;\n  animation: map-object-popup-spin 0.75s linear infinite;\n}\n\n@keyframes map-object-popup-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.map-object-popup__empty {\n  text-align: center;\n  padding: 1.5rem 1rem;\n  color: var(--cfn-text-muted);\n}\n\n.map-object-popup__empty p {\n  margin: 0 0 1rem 0;\n  font-size: 0.875rem;\n}\n\n.map-object-popup__add-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--cfn-accent-primary-muted);\n  border: 1px solid var(--cfn-accent-primary);\n  border-radius: 6px;\n  color: var(--cfn-accent-primary-text);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 0.75rem;\n}\n\n.map-object-popup__add-btn:hover {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-accent-primary-hover);\n  color: var(--cfn-btn-primary-text);\n  transform: translateY(-1px);\n}\n\n.map-object-popup__agg-nodes-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.map-object-popup__agg-node {\n  padding: 0.5rem;\n  background: var(--cfn-bg-tertiary);\n  border: 1px solid var(--cfn-border-muted);\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.map-object-popup__agg-node:hover {\n  background: var(--cfn-bg-elevated);\n  border-color: var(--cfn-border);\n}\n\n.map-object-popup__agg-node-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.375rem;\n  margin-bottom: 0.375rem;\n}\n\n.map-object-popup__agg-node-type {\n  padding: 0.0625rem 0.375rem;\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 3px;\n  color: #c4b5fd;\n  font-size: 0.5rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.theme-light .map-object-popup__agg-node-type {\n  background: rgba(139, 92, 246, 0.1);\n  color: #7c3aed;\n}\n\n.map-object-popup__agg-node-id {\n  flex: 1;\n  color: var(--cfn-text-primary);\n  font-size: 0.6875rem;\n  font-weight: 600;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  text-align: right;\n}\n\n.map-object-popup__agg-node-noi {\n  color: var(--cfn-text-muted);\n  font-size: 0.5625rem;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  margin-bottom: 0.25rem;\n  padding-bottom: 0.25rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n}\n\n.map-object-popup__agg-node-description {\n  color: var(--cfn-text-secondary);\n  font-size: 0.625rem;\n  line-height: 1.3;\n  margin-bottom: 0.375rem;\n}\n\n.map-object-popup__agg-node-actions {\n  display: flex;\n  gap: 0.375rem;\n  justify-content: flex-end;\n}\n\n.map-object-popup__agg-node-btn {\n  padding: 0.375rem 0.625rem;\n  background: var(--cfn-accent-primary-muted);\n  border: 1px solid var(--cfn-accent-primary);\n  border-radius: 4px;\n  color: var(--cfn-accent-primary);\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.map-object-popup__agg-node-btn:hover {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-accent-primary-hover);\n  color: var(--cfn-btn-primary-text);\n  transform: translateY(-1px);\n}\n\n/* More Actions Dropdown */\n.map-object-popup__more-actions {\n  position: relative;\n}\n\n.map-object-popup__more-dropdown {\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  right: 0;\n  min-width: 150px;\n  background: var(--cfn-popup-bg);\n  border: 1px solid var(--cfn-border);\n  border-radius: 6px;\n  box-shadow: var(--cfn-shadow-lg);\n  z-index: 100;\n  overflow: hidden;\n}\n\n.map-object-popup__more-item {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  color: var(--cfn-text-secondary);\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.map-object-popup__more-item:last-child {\n  border-bottom: none;\n}\n\n.map-object-popup__more-item:hover {\n  background: var(--cfn-accent-primary-muted);\n  color: var(--cfn-accent-primary-text);\n}\n\n.map-object-popup__more-item i {\n  width: 1rem;\n  text-align: center;\n  font-size: 0.875rem;\n}\n\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .map-object-popup__header {\n    padding: 0.625rem 0.875rem;\n  }\n\n  .map-object-popup__actions {\n    padding: 0.5rem 0.875rem;\n    gap: 0.3125rem;\n  }\n\n  .map-object-popup__action-btn {\n    padding: 0.4375rem 0.3125rem;\n    font-size: 0.5625rem;\n  }\n\n  .map-object-popup__action-btn i {\n    font-size: 0.9375rem;\n  }\n\n  .map-object-popup__properties-section {\n    padding: 0.625rem 0.875rem;\n  }\n\n  .map-object-popup__footer {\n    padding: 0.5rem 0.875rem;\n    flex-direction: column;\n    gap: 0.375rem;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   PHOTO MINI-GALLERY STYLES\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.photo-mini-gallery {\n  padding: 8px;\n}\n\n.photo-mini-gallery__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 4px 8px;\n  font-size: 12px;\n  color: var(--cfn-text-secondary, #6b7280);\n}\n\n.photo-mini-gallery__count {\n  font-weight: 500;\n  color: var(--cfn-text-primary, #333);\n}\n\n.photo-mini-gallery__radius {\n  font-size: 11px;\n}\n\n.photo-mini-gallery__grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 6px;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.photo-mini-gallery__item {\n  position: relative;\n  aspect-ratio: 1;\n  cursor: pointer;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--cfn-bg-secondary, #f3f4f6);\n  transition: transform 0.15s ease;\n}\n\n.photo-mini-gallery__item:hover {\n  transform: scale(1.02);\n}\n\n.photo-mini-gallery__item:active {\n  transform: scale(0.98);\n}\n\n.photo-mini-gallery__item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.2s ease;\n}\n\n.photo-mini-gallery__item img[src=\"\"] {\n  opacity: 0;\n}\n\n.photo-mini-gallery__overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 2px 4px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));\n  display: flex;\n  justify-content: flex-end;\n}\n\n.photo-mini-gallery__distance {\n  font-size: 10px;\n  font-weight: 500;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* Entity link badge on thumbnail */\n.photo-mini-gallery__entity {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 4px;\n  background: rgba(0, 0, 0, 0.75);\n}\n\n.photo-mini-gallery__entity-link,\n.photo-mini-gallery__entity-text {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  color: white;\n  text-decoration: none;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.photo-mini-gallery__entity-link:hover {\n  color: #60a5fa;\n  text-decoration: underline;\n}\n\n.photo-mini-gallery__entity-link i,\n.photo-mini-gallery__entity-text i {\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.photo-mini-gallery__entity-link span,\n.photo-mini-gallery__entity-text span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Loading state */\n.photo-mini-gallery--loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px;\n  color: var(--cfn-text-secondary, #6b7280);\n  font-size: 12px;\n}\n\n.photo-mini-gallery__spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--cfn-bg-tertiary, #e5e7eb);\n  border-top-color: var(--cfn-primary, #3b82f6);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* Error state */\n.photo-mini-gallery--error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px;\n  color: var(--cfn-danger, #ef4444);\n  font-size: 12px;\n}\n\n.photo-mini-gallery--error i {\n  font-size: 18px;\n}\n\n/* Empty state */\n.photo-mini-gallery--empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px;\n  color: var(--cfn-text-tertiary, #9ca3af);\n  font-size: 12px;\n}\n\n.photo-mini-gallery--empty i {\n  font-size: 24px;\n}\n\n/* Mobile adjustments */\n@media (max-width: 480px) {\n  .photo-mini-gallery__grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 6px;\n  }\n\n  .photo-mini-gallery__distance {\n    font-size: 11px;\n  }\n}\n\n/* ============================================\n   BFT (Blown Fibre Tubing) Nested Tabs\n   For multiple BFTs on the same conduit\n   ============================================ */\n\n.map-object-popup__bft-content {\n  padding: 0;\n}\n\n.map-object-popup__bft-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 8px 10px;\n  background: var(--cfn-bg-tertiary);\n  border-bottom: 1px solid var(--cfn-border);\n}\n\n.map-object-popup__bft-tab {\n  padding: 4px 10px;\n  background: var(--cfn-bg-secondary);\n  border: 1px solid var(--cfn-border);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--cfn-text-muted);\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-object-popup__bft-tab:hover {\n  background: var(--cfn-bg-primary);\n  color: var(--cfn-text-primary);\n  border-color: #7c3aed; /* violet - BFT accent */\n}\n\n.map-object-popup__bft-tab.active {\n  background: #7c3aed; /* violet - BFT accent */\n  color: #ffffff;\n  border-color: #7c3aed;\n}\n\n/* BFT properties within content */\n.map-object-popup__bft-content .map-object-popup__properties-section {\n  padding: 8px 10px;\n}\n\n.map-object-popup__bft-content .map-object-popup__properties {\n  margin: 0;\n}\n\n.map-object-popup__bft-content .map-object-popup__properties dt {\n  font-size: 11px;\n}\n\n.map-object-popup__bft-content .map-object-popup__properties dd {\n  font-size: 12px;\n}\n\n/* ============================================\n   Conduit/Duct Nested Tabs\n   For multiple conduits at the same structure\n   ============================================ */\n\n.map-object-popup__conduit-content {\n  padding: 0;\n}\n\n.map-object-popup__conduit-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 8px 10px;\n  background: var(--cfn-bg-tertiary);\n  border-bottom: 1px solid var(--cfn-border);\n}\n\n.map-object-popup__conduit-tab {\n  padding: 4px 10px;\n  background: var(--cfn-bg-secondary);\n  border: 1px solid var(--cfn-border);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--cfn-text-muted);\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-object-popup__conduit-tab:hover {\n  background: var(--cfn-bg-primary);\n  color: var(--cfn-text-primary);\n  border-color: #ec4899; /* pink - conduit accent */\n}\n\n.map-object-popup__conduit-tab.active {\n  background: #ec4899; /* pink - conduit accent */\n  color: #ffffff;\n  border-color: #ec4899;\n}\n\n/* Conduit properties within content */\n.map-object-popup__conduit-content .map-object-popup__properties-section {\n  padding: 8px 10px;\n}\n\n.map-object-popup__conduit-content .map-object-popup__properties {\n  margin: 0;\n}\n\n.map-object-popup__conduit-content .map-object-popup__properties dt {\n  font-size: 11px;\n}\n\n.map-object-popup__conduit-content .map-object-popup__properties dd {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
